import axiosClient from ".";
class GoogleSignInAPI {
  static google_signin(data) {
    return axiosClient.post("/google_signins.json",data);
  }
}
export default GoogleSignInAPI;